import { message } from "antd";
import { formatNumber } from "../../../components/utils/FormatNumber";
import { useCallback, useEffect, useState } from "react";
import { useAccount } from "wagmi";
import { apiLaunchPad } from "../../../api/apiLaunchPad";
import { formatDateWithSuffix } from "../../../helpers/formatter";
import { shortenAddress } from "../../../helpers";

const ProjectInfo = (props: any) => {
  let dataDetail = props?.data;
  const { address }: any = useAccount();

  function handleCopy(address: any): void {
    navigator.clipboard.writeText(address);
    message.success({
      type: "success",
      content: "Copied Successfully",
      className: "custom-class",
      duration: 2,
    });
  }
  function goToLink(link: any): void {
    window.open(link);
  }

  const [solanaAddress, setSolanaAddress] = useState("");

  const handleGetSolanaAdress = useCallback(async () => {
    if (dataDetail?.id) {
      try {
        const response = await apiLaunchPad.getSolanaAddres(
          address,
          dataDetail.id.toString()
        );
        if (response?.data && response?.data?.claim_address) {
          setSolanaAddress(response?.data?.claim_address);
        }
      } catch (error) {
        console.log(error);
      }
    }
  }, [address, dataDetail]);
  useEffect(() => {
    handleGetSolanaAdress();
  }, [handleGetSolanaAdress]);

  return (
    <>
      <div className="group3">
        <div className="project-text">
          <img src="/images/detail-ido/project-info.svg" alt="" />
        </div>
        <div className="group3-box2">
          <div className="box2-left">
            <div className="box-item">
              <div className="box-item-left">Price per Token</div>
              <div className="box-item-right">
                {formatNumber(dataDetail?.price, 8)}{" "}
                {dataDetail?.currency?.symbol}
              </div>
            </div>
            <div className="box-item">
              <div className="box-item-left">Total Raise</div>
              <div className="box-item-right blu">
                {formatNumber(dataDetail?.total_raise, 8)}{" "}
                {dataDetail?.currency?.symbol}
              </div>
            </div>
            <div className="box-item">
              <div className="box-item-left">Refund Term</div>
              <div className="box-item-right">
                {dataDetail?.refund_term || "TBA"}
              </div>
            </div>
            <div className="box-item">
              <div className="box-item-left">IMC</div>
              <div className="box-item-right">
                ${formatNumber(dataDetail?.imc, 8)}
              </div>
            </div>
            <div className="box-item">
              <div className="box-item-left">Total Supply</div>
              <div className="box-item-right">
                {formatNumber(dataDetail?.total_imc, 8)}{" "}
                {dataDetail?.token?.symbol}
              </div>
            </div>
            <div className="box-item box-item-last">
              <div className="box-item-left">FDV</div>
              <div className="box-item-right">
                {dataDetail?.fdv
                  ? `$${formatNumber(dataDetail?.fdv, 8)}`
                  : "--"}
              </div>
            </div>
          </div>
          <div className="box2-right">
            <div className="box-item">
              <div className="box-item-left">Accepted Currency</div>
              <div className="box-item-right">{dataDetail?.currency?.name}</div>
            </div>
            <div className="box-item">
              <div className="box-item-left">Join Network</div>
              <div className="box-item-right img-network">
                <img src={dataDetail?.currency?.chain?.logo} alt="" />{" "}
                {dataDetail?.currency?.chain?.name}
              </div>
            </div>
            <div className="box-item">
              <div className="box-item-left">Token Network</div>
              <div className="box-item-right img-network">
                <img src={dataDetail?.token?.chain?.logo} alt="" />{" "}
                {dataDetail?.token?.chain?.name}
              </div>
            </div>
            <div className="box-item">
              <div className="box-item-left">Vesting Schedule</div>
              <div className="box-item-right">
                {dataDetail?.vesting_schedule || "TBA"}
              </div>
            </div>
            {dataDetail?.tax && (
              <div className="box-item">
                <div className="box-item-left">Tax</div>
                <div className="box-item-right">{dataDetail?.tax}</div>
              </div>
            )}
            <div className="box-item">
              <div className="box-item-left">Listing Date</div>
              <div className="box-item-right">
                {dataDetail?.listing_date
                  ? formatDateWithSuffix(dataDetail?.listing_date)
                  : "TBA"}
              </div>
            </div>
            <div className={`box-item ${solanaAddress ? "" : "box-item-last"}`}>
              <div className="box-item-left">Participants</div>
              <div className="box-item-right">
                {dataDetail?.participants
                  ? formatNumber(dataDetail?.participants, 8)
                  : "--"}
              </div>
            </div>
            {solanaAddress && (
              <div className="box-item">
                <div className="box-item-left">Claim address</div>
                <div className="box-item-right">{solanaAddress}</div>
              </div>
            )}
          </div>
        </div>
        <div className="group3-box1">
          <div className="g3-box1-left">
            <div className="box1-left-text">Contract Address</div>
            <div className="box1-left-num">
              {dataDetail?.token?.address ? (
                <>
                  {shortenAddress(dataDetail?.token?.address, 10, 10)}
                  <img
                    src="/images/detail-ido/copy.png"
                    alt=""
                    onClick={() => handleCopy(dataDetail?.token?.address)}
                  />
                </>
              ) : (
                "TBA"
              )}
            </div>
            <div className="box1-left-num box1-left-num-mo">
              {dataDetail?.token?.address?.slice(0, 5)}...{" "}
              {dataDetail?.token?.address?.slice(-5)}
              <img
                src="/images/detail-ido/copy.png"
                alt=""
                onClick={() => handleCopy(dataDetail?.token?.address)}
              />
            </div>
          </div>
          <div className="g3-box1-right">
            {dataDetail?.audit_link !== "" ? (
              <div
                className="item-link"
                onClick={() => goToLink(dataDetail?.audit_link)}
              >
                Audit
              </div>
            ) : (
              <div className="item-link">Audit</div>
            )}

            {dataDetail?.whitepaper_link !== "" ? (
              <div
                className="item-link"
                onClick={() => goToLink(dataDetail?.whitepaper_link)}
              >
                Whitepaper
              </div>
            ) : (
              <div className="item-link">Whitepaper</div>
            )}

            {dataDetail?.tokenomics_link !== "" ? (
              <div
                className="item-link"
                onClick={() => goToLink(dataDetail?.tokenomics_link)}
              >
                Tokenomics
              </div>
            ) : (
              <div className="item-link">Tokenomics</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectInfo;
